/*
  Kompakte Perioden-Kennzahlen unterhalb des Shiftplan-Rasters.
*/

import React from "react";
import { Box, Typography } from "@mui/material";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { IconHoliday, IconTime } from "../../../../design-system/icons";
import ShiftplanTooltip from "../tooltips/ShiftplanTooltip";

const HOURS_FORMATTER = new Intl.NumberFormat("de-CH", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const COUNT_FORMATTER = new Intl.NumberFormat("de-CH", {
  maximumFractionDigits: 0,
});

function formatHours(value) {
  return `${HOURS_FORMATTER.format(Number(value || 0))}h`;
}

function formatCount(value) {
  return COUNT_FORMATTER.format(Math.max(0, Math.round(Number(value || 0))));
}

function PeriodSummaryItem({ icon, value, label, tone }) {
  return (
    <ShiftplanTooltip title={label} placement="top" describeChild>
      <Box className={`spv2-period-summary-item is-${tone}`} aria-label={`${label}: ${value}`}>
        <span className="spv2-period-summary-icon" aria-hidden="true">
          {icon}
        </span>
        <Typography component="span" className="spv2-period-summary-value">
          {value}
        </Typography>
      </Box>
    </ShiftplanTooltip>
  );
}

export default function PeriodSummaryBar({ summary, scopeLabel = "Aktueller Zeitraum" }) {
  const stats = summary || {};

  return (
    <Box className="spv2-period-summary" aria-label={`${scopeLabel} Statistik`}>
      <Typography component="span" className="spv2-period-summary-scope">
        {scopeLabel}
      </Typography>
      <PeriodSummaryItem
        tone="hours"
        icon={<IconTime fontSize="small" />}
        value={formatHours(stats.plannedHours)}
        label="Eingeplante Stunden"
      />
      <PeriodSummaryItem
        tone="shifts"
        icon={<WorkOutlineOutlinedIcon fontSize="small" />}
        value={formatCount(stats.shiftCount)}
        label="Schichten"
      />
      <PeriodSummaryItem
        tone="absences"
        icon={<EventBusyOutlinedIcon fontSize="small" />}
        value={formatCount(stats.absenceCount)}
        label="Absenzen"
      />
      <PeriodSummaryItem
        tone="vacation"
        icon={<IconHoliday fontSize="small" />}
        value={formatCount(stats.vacationCount)}
        label="Ferien"
      />
    </Box>
  );
}
